import React from 'react';
import styled from 'styled-components';

import TourGuide from 'src/components/Banners/TourGuide';
import { FLIGHTS_COMPONENT_ID } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import { FlightsList } from '../../../containers/Flights';

import { FiltersPanelMobile } from '../../FlightsFilterPanel';
import ShowFiltersButton from '../ShowFiltersButton';

import EmptyFlights from '../EmptyFlights';

import type { PropsFromRedux } from '.';

const baseCls = 'checkout-flights';

interface FlightsProps extends PropsFromRedux {
  isPackageRouteInView: boolean;
}

export const Flights = (props: FlightsProps): JSX.Element => {
  const {
    showEmptyFlightsSkeleton,
    showFiltersModal,
    isPackageRouteInView,
    isMobile,
    isHotelOnly,
  } = props;

  return (
    <div id={FLIGHTS_COMPONENT_ID} className={baseCls}>
      {!showEmptyFlightsSkeleton ? (
        <>
          {isMobile && <StyledTourGuide isMobile isHotelOnly={isHotelOnly} />}
          <FlightsList />
          {showFiltersModal ? <FiltersPanelMobile /> : null}
          <ShowFiltersButton isPackageRouteInView={isPackageRouteInView} />
        </>
      ) : (
        <EmptyFlights />
      )}
    </div>
  );
};

const StyledTourGuide = styled(TourGuide)`
  margin-bottom: 12px;
`;
